import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Button from 'apollo-react/components/Button';
import axiosInstance from '../../../axiosInstance';

const ZIP_MIME = 'application/zip';

/**
 * Downloads a zip of the requests the current user can see: one Excel workbook per
 * workflow, version tabs inside, one row per request with every form/subform value.
 * Scope is decided server-side from the caller's role.
 */
const ExportRequestsButton = () => {
  const { t } = useTranslation();
  const [exporting, setExporting] = useState(false);

  const handleExport = useCallback(async () => {
    setExporting(true);
    try {
      const response = await axiosInstance.get('/api/requests/export', {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: ZIP_MIME })
      );
      const link = document.createElement('a');
      link.href = url;
      link.download = `requests-export-${new Date().toISOString().slice(0, 10)}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting requests:', error);
      toast.error(t('Failed to export requests'), { position: 'top-center' });
    } finally {
      setExporting(false);
    }
  }, [t]);

  return (
    <Button
      variant="secondary"
      size="small"
      onClick={handleExport}
      disabled={exporting}
    >
      {exporting ? t('Exporting...') : t('export')}
    </Button>
  );
};

export default ExportRequestsButton;
